import absoluteUrl from 'next-absolute-url'

import PrivacyPolicy from 'containers/PrivacyPolicy'

import Layout from 'components/Layout'
import MetaTags from 'components/MetaTags'

import { data } from 'constant/term-legal-policy'

export default function Index({ canonical }) {
  const title = data?.privacyPolicy?.title || 'ข้อตกลงความเป็นส่วนตัว (Privacy Policy)'
  const metaTitle = `24FIX | ${title}`
  const metaDescription = `24FIX | ${title}`

  return (
    <>
      <MetaTags title={metaTitle} description={metaDescription} pathUrl={canonical} />

      <Layout>
        <PrivacyPolicy data={data} />
      </Layout>
    </>
  )
}

export async function getServerSideProps(context) {
  const { req } = context
  const { origin } = absoluteUrl(req)

  return {
    props: JSON.parse(
      JSON.stringify({
        canonical: `${origin}/privacy-policy`,
      })
    ),
  }
}
